// extracted by css-extract-rspack-plugin
export default {"clamp":"pniAg4kJVNEue7eW","active":"UQbXB1SncJchEp3k"};